import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
export const EnableMemberProfileSyncDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EnableMemberProfileSync"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enableMemberProfileSync"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"aaBlockSyncUntil"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"EnableMemberProfileSync","document":EnableMemberProfileSyncDocument}} as const;
export type EnableMemberProfileSyncMutationVariables = Types.Exact<{
  memberId: Types.Scalars['ID']['input'];
}>;


export type EnableMemberProfileSyncMutation = (
  { __typename: 'Mutation' }
  & { enableMemberProfileSync?: Types.Maybe<(
    { __typename: 'Member' }
    & Pick<Types.Member, 'id' | 'aaBlockSyncUntil'>
  )> }
);

export type EnableMemberProfileSyncMutationFn = Apollo.MutationFunction<
  EnableMemberProfileSyncMutation,
  EnableMemberProfileSyncMutationVariables
>;

/**
 * __useEnableMemberProfileSyncMutation__
 *
 * To run a mutation, you first call `useEnableMemberProfileSyncMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableMemberProfileSyncMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableMemberProfileSyncMutation, { data, loading, error }] = useEnableMemberProfileSyncMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useEnableMemberProfileSyncMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EnableMemberProfileSyncMutation,
    EnableMemberProfileSyncMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EnableMemberProfileSyncMutation,
    EnableMemberProfileSyncMutationVariables
  >(EnableMemberProfileSyncDocument, options);
}
export type EnableMemberProfileSyncMutationHookResult = ReturnType<
  typeof useEnableMemberProfileSyncMutation
>;
export type EnableMemberProfileSyncMutationResult =
  Apollo.MutationResult<EnableMemberProfileSyncMutation>;
export type EnableMemberProfileSyncMutationOptions = Apollo.BaseMutationOptions<
  EnableMemberProfileSyncMutation,
  EnableMemberProfileSyncMutationVariables
>;
